import * as React from 'react';
import ReactWebChat, { createDirectLine, createStore } from 'botframework-webchat';
import AdaptiveCardContent from 'botframework-webchat';
import BotHeader from './header';
import IChatbotProps from '../Interface/IChatbotProps';

import RatingStars from './RatingStars';
import PushNotification from './PushNotification';
import UserValidator from './UserValidator'
import Loading from './Loading';
import CustomStreamingTextCard from "./CustomStreamingTextCard";



declare global {
    interface Window {

        simpleUpdateIn: any;
    }
}

interface JQuery {
    emojiPicker(): void;


}

interface WebChatViewProps {
    language: string;
    toggleFn: any;
    chatbotsettings: IChatbotProps

}

interface WebChatViewState {
    loading: boolean;
    rateStars: boolean;
    showPushNotification: boolean;
    showValidatorForm: boolean;
    queueText: string;
    avt: boolean;
}

class WebChatBot extends React.Component<WebChatViewProps, WebChatViewState> {
    constructor(props: WebChatViewProps) {
        super(props);
    }

    toggleFn = () => {
        this.props.toggleFn();
    }
    state: WebChatViewState = {
        loading: true,
        rateStars: false,
        showPushNotification: false,
        showValidatorForm: false,
        queueText: '',
        avt:false

    };
    childRef: React.RefObject<RatingStars> = React.createRef();

    pushNotificationRef: React.RefObject<PushNotification> = React.createRef();
    headerBoxRef: React.RefObject<BotHeader> = React.createRef();
    userValidatorRef: React.RefObject<UserValidator> = React.createRef();
    LoadingRef: React.RefObject<Loading> = React.createRef();

    convidval: any;
    userval: any;
    channelObj: any = {};
    emailid: string = '';
    username: string = '';
    freshUserid: any = '';
    chatrestartflag: boolean = true;
    isInactiveFired: boolean = false;
    conversationIdHistoryCSV: any;
    webChatStore: any;
    token: string = '';
    convidPushNotification: any;
    directLine: any = null;
    ratingValueForBot: number = 0;
    ratingType: string = '';
    isRatingFiredBefore: boolean = false;
    isReload: boolean = false;
    botHeaderText: string = this.props.chatbotsettings.headertext;

    queueCount: any = "0";
    isMaximized: boolean = false;

    arrId = [""];
    prevAction: any;
    yesNovarDisable: any;

    // Needs to be addedin configuration
    timeOutTime: any = parseInt(this.props.chatbotsettings.timeouttime);
    restartTime: any = parseInt(this.props.chatbotsettings.restarttime);

    createWebChatStore = () => createStore({},
        (store: any) => (next: any) => {
            return (action: any) => {

                let interval;
                let checkFeedbackInterval: any;
                let elem: any;
                var jsnDate;

                var dt = new Date();

                jsnDate = [{ 'date': dt }];
                jsnDate = JSON.stringify(jsnDate);
                if (!this.isMaximized) {
                    localStorage.setItem('lastvisit', jsnDate);
                };
                if (action.payload && action.payload.directLine) {
                    const subscription = action.payload.directLine.connectionStatus$.subscribe({
                        next: (value: any) => {
                            if (value === 3 || value === 4) {
                                //this.toggleFn();
                                localStorage.removeItem(action.payload.activity.conversation.id);
                            }
                        }
                    });
                }



                if (action.type === 'DIRECT_LINE/CONNECT_FULFILLED') {
                    var vl = action.payload.directLine.userIdOnStartConversation;

                    if (!this.isReload) {
                        vl = 'false';
                        localStorage.removeItem("isPush");
                        localStorage.removeItem("isRating");
                    }
                    else {
                        vl = 'true';
                        this.isReload = true;
                    }

                    store.dispatch({
                        type: 'WEB_CHAT/SEND_EVENT',
                        payload: {
                            name: "webchat/join",
                            value: { data: { locale: this.props.language, isWelcome: vl } }
                        }
                    });

                    store.dispatch({
                        type: 'WEB_CHAT/SEND_MESSAGE',
                        payload: {
                            text: "__startchat__",
                            value: { data: { locale: this.props.language, isWelcome: vl } }
                        }
                    });

                }


                if (action.type === 'DIRECT_LINE/INCOMING_ACTIVITY') {

                    // -----button disable Coding start---------// 
                    //commented by Yashesh on 3/10 12:37 AM
                    //var adaptivebutton = document.getElementsByClassName("ac-pushButton"); 
                    //for (let i = 0; i < adaptivebutton.length; i++)
                    //{
                    //    const slide = adaptivebutton[i];
                    //    if (slide instanceof HTMLElement)
                    //    {
                    //        slide.setAttribute('disabled', "disabled");
                    //    }
                    //}
                    // -----button disable Coding End---------//
                    if (action.payload.activity.name === 'Feedbackend') {

                        localStorage.setItem("isRating", "true");

                    }

                    if (action.payload.activity.name === 'QueueTriggerEvent') {

                        if (!this.headerBoxRef.current) {
                            return
                        }
                        this.headerBoxRef.current.setCountValueFn(this.state.queueText + ": " + action.payload.activity.value);

                    }
                    if (action.payload.activity.name === 'DeleteTriggerEventFromQueue') {

                        if (!this.headerBoxRef.current) {
                            return
                        }
                        this.headerBoxRef.current.hideCountValueFn('no val');
                    }
                    if (action.payload.activity.name === 'FreshUserId') {

                        localStorage.setItem('FreshConversation', action.payload.activity.value);
                    }


                    if (action.payload.activity.name === 'starrating') {
                        if (!this.childRef.current) {
                            return;
                        }
                        if (this.isReload !== true) {
                            this.ratingType = action.payload.activity.value;
                            this.childRef.current.updateStarsShowFn();
                            const selectedRating = this.childRef.current.getRatingValueFn();
                            localStorage.setItem("isRating", "true");
                        }
                        else {
                            var reloadDifferenceinSec = new Date().getTime() - new Date(action.payload.activity.timestamp).getTime();
                            var diffInSeconds = reloadDifferenceinSec / 1000;
                            if (diffInSeconds < 10) {
                                this.ratingType = action.payload.activity.value;
                                this.childRef.current.updateStarsShowFn();
                                const selectedRating = this.childRef.current.getRatingValueFn();
                                localStorage.setItem("isRating", "true");
                            }
                        }
                    }

                    // to validate email address
                    if (action.payload.activity.name === 'useremailvalidateevent') {
                        if (!this.userValidatorRef.current) {
                            return;
                        }
                        if (this.isReload !== true) {
                            this.userValidatorRef.current.updateShowPopUp(this.convidPushNotification);
                        }
                    }

                    if (action.payload.activity.name === 'uservalidateevent') {
                        if (!this.userValidatorRef.current) {
                            return;
                        }
                        if (this.isReload !== true) {

                            this.userValidatorRef.current.updateShowPopUp(this.convidPushNotification);
                        }
                    }
                    if (action.payload.activity.name === 'uservalidated') {
                        var adaptivebutton = document.getElementsByClassName('ac-pushButton');
                        for (let i = 0; i < adaptivebutton.length; i++) {
                            const slide = adaptivebutton[i];

                            if (slide instanceof HTMLElement) {
                                slide.style.display = "none";
                            }
                        }
                    }
                    if (action.payload.activity.name === "wresolvedevent") {
                        var adaptivebutton =
                            document.getElementsByClassName("ac-pushButton");
                        for (let i = 0; i < adaptivebutton.length; i++) {
                            const slide = adaptivebutton[i];

                            if (slide instanceof HTMLElement) {
                                slide.style.display = "none";
                            }
                        }
                    }

                    if (action.payload.activity.name === 'pushnotificationevent') {
                        if (!this.pushNotificationRef.current) {
                            return;
                        }

                        if (this.isReload !== true) {
                            this.convidPushNotification = localStorage.getItem('gtaacid');
                            if (this.convidPushNotification !== null) {
                                this.convidPushNotification = this.convidPushNotification.toString();
                            }
                            this.pushNotificationRef.current.updateShowPopUp(this.convidPushNotification);
                            localStorage.setItem("isPush", "true");
                        }

                    }

                    if (this.convidval == null) {
                        localStorage.setItem('gtaacid', action.payload.activity.conversation.id);
                        localStorage.setItem('token', this.token);
                    }
                    if (this.userval === undefined) {
                        this.userval = null;
                    }
                    if (this.userval === null) {
                        this.channelObj = action.payload.activity.channelData;
                        for (var prop in this.channelObj) {

                            if (prop === 'Data') {
                                localStorage.setItem('userinfo', this.channelObj[prop]);
                                var obj = JSON.parse(this.channelObj[prop]);
                                this.username = obj.Name;

                                this.emailid = obj.Email;

                            }
                        }
                    }
                    const { activity } = action.payload;


                }

                if (action.type === 'DIRECT_LINE/POST_ACTIVITY') {

                    var datee = new Date()
                    var date = datee + " milliseconds-" + datee.getMilliseconds();

                    localStorage.setItem('start time', date);

                    this?.LoadingRef?.current?.showLoader();
                    store.dispatch({ type: 'WEB_CHAT/SET_SEND_TIMEOUT', payload: { sendTimeout: 20000 } });
                    var uservals = localStorage.getItem('userinfo');

                    if (uservals != null) {
                        var obj1 = JSON.parse(uservals);
                        this.username = obj1.Name;

                        this.emailid = obj1.Email;

                    }
                    var freshIdObj = localStorage.getItem('FreshConversation');
                    if (freshIdObj !== null) {
                        this.freshUserid = freshIdObj.toString();
                    }
                    else {
                        this.freshUserid = '';
                    }
                    if (uservals != null) {

                        action = window.simpleUpdateIn(
                            action,
                            ['payload', 'activity', 'channelData'],
                            () => ({
                                'username': this.username,
                                'email': this.emailid,
                                'csvconvid': this.conversationIdHistoryCSV,
                                'freshUserid': this.freshUserid
                            })
                        )
                    }
                }
                if (action.type === 'DIRECT_LINE/POST_ACTIVITY_FULFILLED') {
                    var datee2 = new Date()

                    var datenew = datee2 + " milliseconds-" + datee2.getMilliseconds();

                    localStorage.setItem('Response fullfilled time', datenew);

                }
                

                if (action.type === 'WEB_CHAT/SEND_MESSAGE') {

                    if (action.payload.text === 'no-negative-feedback' || action.payload.text === 'yes-positive-feedback' || action.payload.text === '1star' || action.payload.text === '2star'
                        || action.payload.text === '3star' || action.payload.text === '4star' ||
                        action.payload.text === '5star') {
                        store.dispatch({
                            type: 'WEB_CHAT/SEND_MESSAGE_BACK',
                            payload: {
                                text: action.payload.text,
                            }
                        });
                        action.payload.text = '';
                    }
                    clearTimeout(interval);
                } else if (action.type === 'DIRECT_LINE/INCOMING_ACTIVITY' && action.payload.activity.name !== 'inactive') {
                    // Added by Akshaya on 14 Sep 2023
                    // Commented by Anurag on 18 Sep 2023
                   /* if (action.payload.activity.attachments) {
                        if (action.payload.activity.attachments.length !== 0) {
                            if (this.arrId.includes(action.payload.activity.attachments[0].content.body[0].id)) {
                                if (this.prevAction.payload.activity.attachments[0].content.body[0].id === action.payload.activity.attachments[0].content.body[0].id) {
                                    this.prevAction.payload.activity.attachments[0].content.body[0].text += action.payload.activity.attachments[0].content.body[0].text;
                                }
                                action = Object.assign({}, this.prevAction);
                            } else {
                                if (action.payload.activity.attachments[0].content.body[0].id) {
                                    this.arrId.push(action.payload.activity.attachments[0].content.body[0].id);
                                    this.prevAction = action;
                                }
                            }
                        }
                    }*/
                    //Added by ANurag on 18  Sep 2023
                    if (action.payload.activity.attachments) {
                        if (action.payload.activity.attachments.length !== 0) {
                            if (action.payload.activity.attachments[0].contentType === 'application/vnd.custom-stream-text') {
                                if (this.arrId.includes(action.payload.activity.attachments[0].content.body[0].id)) {
                                    if (this.prevAction.payload.activity.attachments[0].content.body[0].id === action.payload.activity.attachments[0].content.body[0].id) {
                                        this.prevAction.payload.activity.attachments[0].content.body[0].text += action.payload.activity.attachments[0].content.body[0].text;
                                        this.prevAction.payload.activity.attachments[0].content.body[0].thumbsflag = action.payload.activity.attachments[0].content.body[0].thumbsflag;
                                    }
                                    action = Object.assign({}, this.prevAction);
                                } else {
                                    if (action.payload.activity.attachments[0].content.body[0].id) {
                                        this.arrId.push(action.payload.activity.attachments[0].content.body[0].id);
                                        this.prevAction = action;
                                    }
                                }
                            }
                        }
                    }
                   var adaptivecard = document.getElementsByClassName("ac-adaptiveCard");
                    var adaptivebutton = document.getElementsByClassName("ac-pushButton");
                    var thumbsbut = document.getElementsByClassName("thumb-image");
                    var okcard = document.getElementById("Name")
                    var okenabled = localStorage.getItem('enableOkButton');
                    var divmenu = document.getElementsByClassName("ac-actionSet");
                    //Commented out as part of chatbot enhancments(Previous button active) on 12-July-23
                    //Uncommented by Anurag on 25-08-2023
                    document.querySelectorAll('p').forEach(p => {
                        if (p.textContent?.includes('1 attachment.')) {
                            p.setAttribute('aria-hidden', 'true');
                            p.style.display = "none";
                            p.setAttribute("tabindex", "-1");
                            p.innerText = "";

                        }
                    });
                    setTimeout(function () {
                        for (let i = 0; i <= divmenu.length + 5; i++) {
                            const slide = adaptivecard[i];
                            if (slide instanceof HTMLElement) {
                                slide.setAttribute('role', 'presentation');
                                slide.setAttribute('aria-live', 'polite')
                                slide.setAttribute('tabindex', '0')
                            }
                        }
                        for (let i = 0; i <= divmenu.length + 5; i++) {
                            const divSlide = divmenu[i];
                            if (divSlide instanceof HTMLElement) {
                                divSlide.removeAttribute("role")
                            }
                        }
                        for (let i = 0; i <= adaptivebutton.length +5; i++) {

                            const bslide = adaptivebutton[i];
                            if (bslide instanceof HTMLElement) {
                                bslide.setAttribute('role', 'button')
                            }
                        }
                        document.querySelectorAll('p').forEach(p => {
                            if (p.textContent?.includes('1 attachment.')) {
                                p.setAttribute('aria-hidden', 'true')
                                p.style.display = "none"
                                p.setAttribute("tabindex", "-1")
                                p.innerText = ""

                            }
                        });
                    }, 100);
                    
                    for (let i = 0; i < adaptivebutton.length - this.yesNovarDisable; i++) {

                        const slide = adaptivebutton[i];
                        if (slide instanceof HTMLElement) {
                            slide.style.pointerEvents = "none";
                            slide.tabIndex = -1;
                            slide.style.touchAction = "none";
                            slide.style.userSelect = "none";
                            slide.blur();
                            if (slide.getAttribute('aria-label') == "OK" || slide.getAttribute('aria-label') == "Resolved" || slide.getAttribute('aria-label') == "Not Resolved") {
                                localStorage.setItem('enableOkButton', "true");
                                okenabled = localStorage.getItem('enableOkButton');
                            }
                            if (okenabled == "true") {
                                slide.style.pointerEvents = "auto";
                                slide.tabIndex = 0;
                                slide.style.touchAction = "auto";
                                slide.style.userSelect = "auto";
                                okenabled = "false";

                            }
                        }

                    }
                    this.yesNovarDisable = 0;
                    for (let i = 0; i < thumbsbut.length - 2; i++) {
                        
                        const butSlide = thumbsbut[i];

                        if (butSlide instanceof HTMLElement) {
                          
                            butSlide.style.pointerEvents = "none";
                            butSlide.tabIndex = -1;
                            butSlide.style.touchAction = "none";
                            butSlide.style.userSelect = "none";
                            butSlide.blur();

                        }
                    }

                   /* Refresh code- Un used 
                   if (this.isInactiveFired === true) {
                        if (this.timeOutTime !== null && this.timeOutTime !== 0) {
                            interval = setTimeout(() => {
                                localStorage.removeItem('gtaacid');
                                localStorage.removeItem("isPush");
                                this.toggleFn();
                            }, this.timeOutTime * 60000)

                        }
                    }
                    else {
                        clearInterval(interval);
                        if (this.timeOutTime !== null && this.timeOutTime !== 0) {
                            this.isMaximized = true;
                            interval = setTimeout(() => {

                                if (this.chatrestartflag === true) {
                                    store.dispatch({
                                        type: 'WEB_CHAT/SEND_EVENT',
                                        payload: {
                                            name: 'inactive',
                                            value: ''
                                        }
                                    });

                                    this.chatrestartflag = false;
                                    this.isInactiveFired = true;
                                    this.isMaximized = false;

                                }
                            }, this.restartTime * 60000)
                        }
                    }*/

                }
                return next(action)
            };
        });

    attachmentMiddleware = () => (next: any) => (card: any) => {

        if (card.attachment.content.body != undefined) {


            if (card.attachment.content.body[0].aigenerative === true) {

//console.log("yes we got ai response")

                var val = card.attachment.content.body[0].aigenerative;

             //   console.log(val);

                this.state.avt = true;


            } else {

               // console.log("no AI response here")

                this.state.avt = false;

            }
        }
         this?.LoadingRef?.current?.showLoader();
        
        switch (card.attachment.contentType) {
            case "application/vnd.custom-stream-text":
                /*var datee = new Date();
                var date = datee + " milliseconds-" + datee.getMilliseconds();
                console.log(card.attachment.content.body[0].text + "" + datee);*/
                if (card.attachment.content.body[0].thumbsflag == true) {
                    this?.LoadingRef?.current?.removeLoader();
                }
                //else {
                //    this?.LoadingRef?.current?.showLoader();
                //}
                return (
                    <CustomStreamingTextCard
                        text={card.attachment.content.body[0].text}
                        id={card.attachment.content.body[0].id}
                        msgfeedback={this.msgfeedback}
                        showthumb={card.attachment.content.body[0].thumbsflag}
                    />
                );

            default:
                this?.LoadingRef?.current?.removeLoader();
                return next(card);
        }
    }

    avatarMiddleware = () => (next: any) => (...args: any) => {

        const [{ fromUser, activity, name }] = args;

        //const mystyle = {

        //    width: "40px",

        //    height: "40px"

        //}

        if (!fromUser) {
            if (activity.attachments[0].contentType == "application/vnd.microsoft.card.adaptive" || activity.attachments[0].content.body[0].thumbsflag == true) {
                this?.LoadingRef?.current?.removeLoader();
            }
            //if (this.state.avt === true) {

            //    return () => <img src={this.props.chatbotsettings.chatbotaiurl} style={mystyle} />;

            //}

        }
        else {
            this?.LoadingRef?.current?.showLoader();
        }

        return next(...args);

    }

    activityMiddleware = () => (next: any) => (card: any) => {
        const { activity } = card
      //  console.log(activity.text)
        if (activity.type == "message" && (activity.text == "__startchat__" || activity.text=="_thumbs_")) {
            return null;
        }
        return next(card)

    };

    ConvertToCSV(parameters: { objArray: any }) {
        let objArray = parameters.objArray;
        var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        var str = '';
        var line = '';
        for (var i = 0; i < array.length; i++) {
            if (line !== '') line += ','
            line += array[i]['convid'];
        }
        str = line;
        return str;
    }

    async GetConfigValues() {
        const response = await fetch(this.props.chatbotsettings.configvaluesurl, {
            headers: {
                'ApiKey': this.props.chatbotsettings.configvaluesurlapikey,
                'Content-type': 'application/json'
            },
            method: 'GET'

        });

        const data = await response.json();
        if (this.props.language === 'fr') {

            this.state.queueText = data.filter((list: any) => list.referenceKey === 'User Queue')[0].frenchMessage;

        }
        else {

            this.state.queueText = data.filter((list: any) => list.referenceKey === 'User Queue')[0].message;

        }
    }

    async fetchToken() {
        let jsonStr;
        var convidval;
        var lastConvID;
        var d;
        let dtCompareString;
        let lastVisitDate;
        let diffInMinutes = 0;



        this.convidval = localStorage.getItem('gtaacid');
        this.userval = localStorage.getItem('userinfo');

        dtCompareString = localStorage.getItem('lastvisit');
        if (dtCompareString !== null && dtCompareString !== '' && this.convidval !== null) {

            var obj = JSON.parse(dtCompareString);
            if (dtCompareString) {
                lastVisitDate = obj[obj.length - 1].date;
                diffInMinutes = (new Date().getTime() - new Date(lastVisitDate).getTime()) / 60000;
                if (this.timeOutTime > 0) {
                    if (diffInMinutes > this.timeOutTime) {
                        localStorage.removeItem('gtaacid');
                        localStorage.removeItem('token');
                        this.convidval = null;
                    }
                }
                else {

                    if (diffInMinutes > this.timeOutTime) {
                        localStorage.removeItem('gtaacid');
                        localStorage.removeItem('token');
                        this.convidval = null;
                    }
                }
            }
        }

        if (this.convidval === 'undefined') {
            this.convidval = null;
        }
        if (this.convidval) {
            var tokenvar = localStorage.getItem('token');
            let tokenVal = '';
            if (tokenvar) {
                if (tokenvar !== null) {
                    tokenVal = tokenvar.toString();
                }


                const res = await fetch(this.props.chatbotsettings.chatjssourceurl + this.convidval + `?watermark=0`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${tokenVal}`,
                    },
                });
                let responseCode = res.status;
                if (responseCode === 200) {
                    this.isReload = true;

                    let { token: directLineToken } = await res.json();

                    this.token = directLineToken;
                    this.directLine = createDirectLine({ token: directLineToken });
                    this.setState({ loading: false });
                }
                else {

                    const res = await fetch(this.props.chatbotsettings.tokengenerateurl, {

                        headers: {
                            'ApiKey': this.props.chatbotsettings.tokenserviceurlapikey,
                            'Content-type': 'application/json'
                        },
                        method: 'GET'

                    });
                    let { token: directLineToken, conversationId } = await res.json();
                    this.token = directLineToken;
                    this.directLine = createDirectLine({ token: directLineToken });
                    this.setState({ loading: false });

                    localStorage.setItem('gtaacid', conversationId);
                    localStorage.setItem('token', this.token);
                    jsonStr = localStorage.getItem('conversationIdHistory');
                    if (jsonStr !== null && jsonStr !== '') {
                        d = new Date();
                        convidval = localStorage.getItem('gtaacid');
                        var obj = JSON.parse(jsonStr);
                        lastConvID = obj[obj.length - 1].convid;

                        if (lastConvID !== convidval && convidval !== null) {
                            obj.push({ 'date': d, 'convid': this.convidval });
                            jsonStr = JSON.stringify(obj);
                            localStorage.setItem('conversationIdHistory', jsonStr);   // 1                       
                            this.conversationIdHistoryCSV = (this.ConvertToCSV({ objArray: jsonStr }));
                        }

                    }
                    else {
                        d = new Date();
                        convidval = localStorage.getItem('gtaacid');
                        if (convidval !== null && convidval !== '') {
                            jsonStr = [{ 'date': d, 'convid': convidval }];
                            jsonStr = JSON.stringify(jsonStr);
                            localStorage.setItem('conversationIdHistory', jsonStr); // 2                       
                            this.conversationIdHistoryCSV = (this.ConvertToCSV({ objArray: jsonStr }));
                        }
                    }
                }
            }

            else {

                const res = await fetch(this.props.chatbotsettings.tokengenerateurl, {

                    headers: {
                        'ApiKey': this.props.chatbotsettings.tokenserviceurlapikey,
                        'Content-type': 'application/json'
                    },
                    method: 'GET'
                });
                let { token: directLineToken, conversationId } = await res.json();

                this.token = directLineToken;
                this.directLine = createDirectLine({ token: directLineToken });
                this.setState({ loading: false });
                localStorage.setItem('gtaacid', conversationId);
                localStorage.setItem('token', this.token);
                jsonStr = localStorage.getItem('conversationIdHistory');
                if (jsonStr !== null && jsonStr !== '') {
                    d = new Date();
                    convidval = localStorage.getItem('gtaacid');
                    let obj = JSON.parse(jsonStr);
                    lastConvID = obj[obj.length - 1].convid;

                    if (lastConvID !== convidval && convidval !== null) {
                        obj.push({ 'date': d, 'convid': this.convidval });
                        jsonStr = JSON.stringify(obj);
                        localStorage.setItem('conversationIdHistory', jsonStr);
                        this.conversationIdHistoryCSV = (this.ConvertToCSV({ objArray: jsonStr }));
                    }

                }
                else {
                    d = new Date();
                    convidval = localStorage.getItem('gtaacid');
                    if (convidval !== null && convidval !== '') {

                        jsonStr = [{ 'date': d, 'convid': convidval }];
                        jsonStr = JSON.stringify(jsonStr);
                        localStorage.setItem('conversationIdHistory', jsonStr);  //4
                        this.conversationIdHistoryCSV = (this.ConvertToCSV({ objArray: jsonStr }));
                    }
                }
            }
        }
        else {

            const res = await fetch(this.props.chatbotsettings.tokengenerateurl, {

                headers: {
                    'ApiKey': this.props.chatbotsettings.tokenserviceurlapikey,
                    'Content-type': 'application/json'
                },
                method: 'GET'
            });
            let { token: directLineToken, conversationId } = await res.json();

            this.token = directLineToken;
            this.directLine = createDirectLine({ token: directLineToken });
            this.setState({ loading: false });
            localStorage.setItem('gtaacid', conversationId);
            localStorage.setItem('token', this.token);
            jsonStr = localStorage.getItem('conversationIdHistory');
            if (jsonStr !== null && jsonStr !== '') {
                d = new Date();
                convidval = localStorage.getItem('gtaacid');
                let obj = JSON.parse(jsonStr);
                lastConvID = obj[obj.length - 1].convid;

                if (lastConvID !== convidval && convidval !== null) {
                    obj.push({ 'date': d, 'convid': this.convidval });
                    jsonStr = JSON.stringify(obj);
                    localStorage.setItem('conversationIdHistory', jsonStr);
                    this.conversationIdHistoryCSV = (this.ConvertToCSV({ objArray: jsonStr }));
                }

            }
            else {
                d = new Date();
                convidval = localStorage.getItem('gtaacid');
                if (convidval !== null && convidval !== '') {

                    jsonStr = [{ 'date': d, 'convid': convidval }];
                    jsonStr = JSON.stringify(jsonStr);
                    localStorage.setItem('conversationIdHistory', jsonStr);  //4
                    this.conversationIdHistoryCSV = (this.ConvertToCSV({ objArray: jsonStr }));
                }
            }
        }



    }
    componentDidMount(): void {
        this.GetConfigValues();
        this.fetchToken();
        this.yesNovarDisable = 0;
    }

    async sendToWebhook() {
        let conversationId = localStorage.getItem('gtaacid');
        if (conversationId != null) {
            conversationId = conversationId.toString();
        }
        localStorage.removeItem("isRating");
        const dataJson = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ FeedbackJson: this.ratingValueForBot, ConversationId: conversationId, UserName: this.username, Email: this.emailid, RatingType: this.ratingType })
        };
        fetch(this.props.chatbotsettings.freshchatintegrationurl, dataJson);



    }

    async FeedbackCloseEvent() {
        let conversationId = localStorage.getItem('gtaacid');
        if (conversationId != null) {
            conversationId = conversationId.toString();
        }
        localStorage.removeItem("isRating");
        const dataJson = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ NoFeedbackJson: '0', ConversationId: conversationId })
        };
        fetch(this.props.chatbotsettings.freshchatintegrationurl, dataJson);


    }

    //updateRatingValue = (ratingValue: number) => {

    //    this.ratingValueForBot = ratingValue;
    //    this.sendToWebhook();

    //}

    //closedRatingFn = (ratingProps: any) => {
    //    this.FeedbackCloseEvent();

    //}

    updateRatingValue = (ratingValue: number) => {
        localStorage.currentRating = ratingValue;
       // console.log("inside rating");
        this.ratingValueForBot = ratingValue;
        this.sendToWebhook();
    }

    msgfeedback = async (ratingProps: any, msggID: any) => {
        localStorage.setItem("messagerate", ratingProps);
        var tokenvarr = localStorage.getItem("token");
        var convid = localStorage.getItem("gtaacid");
        this.yesNovarDisable = 2;
        if (tokenvarr) {

            const dataJson = {
                method: "POST",
                headers: { "Content-Type": "application/json", Authorization: `Bearer ${tokenvarr}`, },
                body: JSON.stringify({
                    type: "message",
                    value: { data: { value: ratingProps, messageId: msggID, locale: this.props.language} },                    
                    text: "_thumbs_"
                }),
            };
            await fetch(
                this.props.chatbotsettings.chatjssourceurl +
                convid +
                "/activities",
                dataJson
            );
        }
    };

    closedRatingFn = (ratingProps: any) => {
        //this.FeedbackCloseEvent();    
        localStorage.currentRating = ratingProps.ratingValue;
        this.ratingValueForBot = ratingProps.ratingValue;
        this.sendToWebhook();
    }

    updatePushNotification = (pushNotificationReq: object) => {

    }

    updateValidator = (uservalidateReq: object) => {
    }
    render() {
        let chatBot = null;
        let { rateStars } = this.state;



        if (this.state.loading) {
            // @ts-ignore
            chatBot = <div></div>
        }

        if (this.token) {
            this.webChatStore = this.createWebChatStore();
            const adaptiveCardHostConfig = {
                fontFamily: 'Source Sans Pro'
            };
            this.convidval = localStorage.getItem('gtaacid');
            if (this.convidval !== null) {
                this.convidval = this.convidval.toString();
            }

            //if (this.props.language == 'fr') {
            //    this.botHeaderText ='';
            //}
            const botStyle = {

                hideUploadButton: 'true',

                userAvatarImage: '',
                botAvatarInitials: '',
                ButtonTextWrap: 'True',
                suggestedActionLayout: 'stacked',
                suggestedActionTextColor: '#002663',
                suggestedActionBorderColor: 'Blue',
                suggestedActionDisabledBackground: 'White',
                suggestedActionDisabledBorderColor: 'Blue',
                userAvatarInitials: '',
                bubbleFromUserBackground: '#002663',
                bubbleBorderRadius: '7px',
                sendBoxButtonColor: 'Black',
                bubbleFromUserTextColor: 'White',
                bubbleFromUserBorderRadius: '7px',
                transcriptActivityVisualKeyboardIndicatorColor: 'DEFAULT_SUBTLE',
                transcriptActivityVisualKeyboardIndicatorStyle: 'dashed',
                transcriptActivityVisualKeyboardIndicatorWidth: 1,
                transcriptVisualKeyboardIndicatorColor: 'Black',
                transcriptVisualKeyboardIndicatorStyle: 'solid',
                transcriptVisualKeyboardIndicatorWidth: 2,
                primaryFont: 'Source Sans Pro',
                botAvatarImage: this.props.chatbotsettings.chaticonurl

            };
            // @ts-ignore
            chatBot = (
                <div className="chatBox-content">
                    <RatingStars
                        chatbotsettings={this.props.chatbotsettings}
                        ref={this.childRef} updateRatingValue={this.updateRatingValue}
                        locale={this.props.language}
                        closedRatingFn={this.closedRatingFn}
                        rateStars={false} toggleFn={this.toggleFn}></RatingStars>

                    <PushNotification
                        chatbotsettings={this.props.chatbotsettings}
                        locale={this.props.language}
                        ref={this.pushNotificationRef}
                        updatePushNotification={this.updatePushNotification}
                        showPushNotification={this.state.showPushNotification}
                        toggleFn={this.toggleFn}></PushNotification>
                    <UserValidator locale={this.props.language}
                        chatbotsettings={this.props.chatbotsettings}
                        ref={this.userValidatorRef} updateValidator={this.updateValidator}
                        showValidatorForm={this.state.showValidatorForm} toggleFn={this.toggleFn}></UserValidator>


                    <BotHeader toggleFn={this.toggleFn}
                        ref={this.headerBoxRef}
                        title={this.botHeaderText}
                        chatbotsettings={this.props.chatbotsettings} />

                    <Loading ref={this.LoadingRef} showLoader={false} />

                    <ReactWebChat className="webchat-body-custom"
                        adaptiveCardHostsConfig={adaptiveCardHostConfig}
                        locale={this.props.language}
                        directLine={this.directLine}
                        store={this.webChatStore}
                        role="region"
                        styleOptions={botStyle}
                        attachmentMiddleware={this.attachmentMiddleware}
                        avatarMiddleware={this.avatarMiddleware}
                        activityMiddleware={this.activityMiddleware}
                      
                    />
                </div>);
        }
        return (
            chatBot
        );
    }
}

export default WebChatBot;
